/** Compact dollar formatting shared across dashboard widgets ($17.9k / $325 / -$500). */
export function formatMoney(value: number): string {
  const abs = Math.abs(value)
  const formatted = abs >= 1000 ? `$${(abs / 1000).toFixed(1)}k` : `$${Math.round(abs)}`
  return value < 0 ? `-${formatted}` : formatted
}
